var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeMute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.43 9.09979C17.2676 9.02953 17.0895 9.00362 16.9138 9.0247C16.7381 9.04578 16.5712 9.1131 16.43 9.21979L11.65 12.9998H8C7.73478 12.9998 7.48043 13.1051 7.29289 13.2927C7.10536 13.4802 7 13.7346 7 13.9998V19.9998C7 20.265 7.10536 20.5194 7.29289 20.7069C7.48043 20.8944 7.73478 20.9998 8 20.9998H11.65L16.38 24.7798C16.5559 24.9209 16.7744 24.9985 17 24.9998C17.1494 25.0023 17.297 24.9679 17.43 24.8998C17.6002 24.8187 17.744 24.6912 17.8448 24.532C17.9457 24.3728 17.9995 24.1883 18 23.9998V9.99979C17.9995 9.8113 17.9457 9.6268 17.8448 9.46757C17.744 9.30833 17.6002 9.18084 17.43 9.09979ZM16 21.9198L12.62 19.2198C12.4441 19.0786 12.2256 19.0011 12 18.9998H9V14.9998H12C12.2256 14.9985 12.4441 14.9209 12.62 14.7798L16 12.0798V21.9198ZM24.91 16.9998L26.71 15.2098C26.8032 15.1165 26.8772 15.0059 26.9277 14.884C26.9781 14.7622 27.0041 14.6316 27.0041 14.4998C27.0041 14.3679 26.9781 14.2374 26.9277 14.1155C26.8772 13.9937 26.8032 13.883 26.71 13.7898C26.6168 13.6965 26.5061 13.6226 26.3842 13.5721C26.2624 13.5217 26.1319 13.4957 26 13.4957C25.8681 13.4957 25.7376 13.5217 25.6158 13.5721C25.4939 13.6226 25.3832 13.6965 25.29 13.7898L23.5 15.5898L21.71 13.7898C21.5217 13.6015 21.2663 13.4957 21 13.4957C20.7337 13.4957 20.4783 13.6015 20.29 13.7898C20.1017 13.9781 19.9959 14.2335 19.9959 14.4998C19.9959 14.7661 20.1017 15.0215 20.29 15.2098L22.09 16.9998L20.29 18.7898C20.1963 18.8828 20.1219 18.9934 20.0711 19.1152C20.0203 19.2371 19.9942 19.3678 19.9942 19.4998C19.9942 19.6318 20.0203 19.7625 20.0711 19.8844C20.1219 20.0062 20.1963 20.1168 20.29 20.2098C20.383 20.3035 20.4936 20.3779 20.6154 20.4287C20.7373 20.4794 20.868 20.5056 21 20.5056C21.132 20.5056 21.2627 20.4794 21.3846 20.4287C21.5064 20.3779 21.617 20.3035 21.71 20.2098L23.5 18.4098L25.29 20.2098C25.383 20.3035 25.4936 20.3779 25.6154 20.4287C25.7373 20.4794 25.868 20.5056 26 20.5056C26.132 20.5056 26.2627 20.4794 26.3846 20.4287C26.5064 20.3779 26.617 20.3035 26.71 20.2098C26.8037 20.1168 26.8781 20.0062 26.9289 19.8844C26.9797 19.7625 27.0058 19.6318 27.0058 19.4998C27.0058 19.3678 26.9797 19.2371 26.9289 19.1152C26.8781 18.9934 26.8037 18.8828 26.71 18.7898L24.91 16.9998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMute);
export default __webpack_public_path__ + "static/media/volume-mute.4f085506.svg";
export { ForwardRef as ReactComponent };